/**
 * Ovoz qatlami — D-010, D-035, D-036.
 *
 * `features/` kodi FAQAT shu interfeysni ko'radi. Ostida ikkita
 * implementatsiya turadi va ular almashsa yuqoridagi kod o'zgarmaydi:
 *
 *     p2p.ts       BIRLAMCHI. Ikki foydalanuvchi to'g'ridan-to'g'ri.
 *                  Server Germaniyada (D-034) — orqali o'tish
 *                  og'izdan-quloqqa ~90 ms qo'shadi va bu yadro
 *                  mahsulotda seziladi (D-035).
 *     livekit.ts   FALLBACK. P2P ulanmasa. Alohida TURN (coturn)
 *                  o'rniga tayyor room kodi qayta ishlatiladi (D-036).
 *
 * Almashish SHAFFOF: `call` ekrani qaysi yo'l ishlayotganini bilmaydi.
 * `transport` faqat TELEMETRIYA uchun beriladi (M-001) — UI'da
 * ko'rsatilmaydi.
 */

export type Transport = 'p2p' | 'livekit';

export type VoiceState =
  /** Mikrofon so'ralmoqda yoki ulanish ketmoqda. */
  | 'connecting'
  /** Ovoz oqmoqda. */
  | 'connected'
  /** Uzildi, qayta urinilmoqda. */
  | 'reconnecting'
  /**
   * Mikrofonga ruxsat berilmadi yoki qurilma yo'q.
   *
   * `failed` dan ATAYLAB ajratilgan: bu tarmoq muammosi emas va
   * LiveKit'ga o'tish uni HAL QILMAYDI — u yerda ham mikrofon kerak.
   * Foydalanuvchiga aytiladigan gap ham boshqa: "ruxsat bering",
   * "qayta urinib ko'ring" emas.
   */
  | 'no-mic'
  /** Ikkala yo'l ham ishlamadi. */
  | 'failed'
  | 'closed';

/** Brauzer mikrofonni bermadi (rad etildi yoki qurilma yo'q). */
export function isMicError(error: unknown): boolean {
  const name = (error as { name?: string } | null)?.name;
  return (
    name === 'NotAllowedError' ||
    name === 'NotFoundError' ||
    name === 'PermissionDeniedError' ||
    name === 'SecurityError'
  );
}

export interface VoiceHandlers {
  onState: (state: VoiceState) => void;
  /** Suhbatdoshning ovozi. Chaqiruvchi uni `<audio>` ga ulaydi. */
  onRemoteStream: (stream: MediaStream) => void;
}

export interface VoiceSession {
  /** Mikrofonni so'raydi va ulanadi. */
  start(): Promise<void>;
  setMuted(muted: boolean): void;
  /** Ulanishni yopadi va mikrofonni bo'shatadi. */
  stop(): Promise<void>;
  /** M-001 uchun: qaysi yo'l ishladi, ICE qancha vaqt oldi. */
  readonly transport: Transport;
  readonly iceMs: number | null;
  readonly reconnects: number;
}

/** Faqat ovoz. Video hech qachon so'ralmaydi — mahsulot ovozli. */
export const AUDIO_ONLY: MediaStreamConstraints = {
  audio: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
  },
  video: false,
};
